module.exports = __webpack_public_path__ + "fonts/logo.svg?f38c2fc2";